import utils from '../utils/utils';

// כל הפעולות מול השרת. פעולה חדשה צריכה להופיע גם ב-APP_ACTIONS ב-server/src/routes/ver1Router.ts
export const API = {
  // התחברות (Auth.sql). שתיהן מחזירות [1] token, userId, firstName, lastName
  signUp: (params) => utils.requestData('SignUp', params),   // { firstName, lastName, phone, password, isKfarResident }
  signIn: (phone, password) => utils.requestData('SignIn', { phone, password }),
  signOut: () => utils.requestData('SignOut', {}),

  // sort: 'relevance' | 'diff'. resort=true: שינוי מיון של אותו חיפוש — לא נספר שוב בחיפושים הפופולריים
  searchProducts: (q, sort, resort = false) => utils.requestData('SearchProducts', { q, sort, resort }),
  // כל שמות המוצרים והחברות, להשלמה אוטומטית (נטען פעם אחת, ר' SearchTab.jsx)
  getSearchSuggestions: () => utils.requestData('GetSearchSuggestions', {}),
  // נתוני הדשבורד בעמוד הראשי (ר' Dashboard.jsx)
  getDashboard: () => utils.requestData('GetDashboard', {}),
  // רשימת המוצרים שמאחורי משבצת בדשבורד (ProductListModal.jsx). list: 'compared' | 'cheaper' | 'same' | 'gap'
  // storeId — רק ל-cheaper. page מ-0, 50 בעמוד. אותו מבנה תשובה כמו searchProducts
  getProductList: (list, storeId, q, page) => utils.requestData('GetProductList', { list, storeId, q, page }),
  // פידבק: { message, website? (honeypot) }. השם והטלפון נלקחים מהמשתמש המחובר (spAddFeedback)
  sendFeedback: (params) => utils.requestData('AddFeedback', params),
};
